import React, { useState, useEffect, useRef } from "react";
import { Button, Icon } from "semantic-ui-react";
import { sumBy } from "lodash";
import { getProductsCart, CART_UPDATED_EVENT } from "../../../api/cart";
import "./CartButton.scss";

const countCart = () => sumBy(getProductsCart(), (item) => item.quantity || 1);

// "Ver carrito" del flujo "Añadir pedido" del Admin: muestra cuántos platos
// lleva el carrito y da un saltito cada vez que se agrega uno, para que el
// mozo vea que el "+" sí sumó sin tener que entrar al carrito.
export function CartButton(props) {
  const { onClick } = props;
  const [count, setCount] = useState(countCart);
  const [bump, setBump] = useState(false);
  const previous = useRef(count);

  useEffect(() => {
    const update = () => setCount(countCart());
    window.addEventListener(CART_UPDATED_EVENT, update);
    return () => window.removeEventListener(CART_UPDATED_EVENT, update);
  }, []);

  useEffect(() => {
    if (count > previous.current) {
      setBump(true);
      const timeout = setTimeout(() => setBump(false), 400);
      previous.current = count;
      return () => clearTimeout(timeout);
    }
    previous.current = count;
  }, [count]);

  return (
    <Button
      icon
      labelPosition="right"
      primary
      onClick={onClick}
      className={`cart-button-admin${bump ? " cart-button-admin--bump" : ""}`}
    >
      Ver carrito
      <Icon name="shop" />
      {count > 0 && <span className="cart-button-admin__badge">{count}</span>}
    </Button>
  );
}
